import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const postsImporterSelectors = importerSelectors(
  'posts.importer',
)

export default postsImporterSelectors
